import { IComponentOptions, IScope } from "angular";
import { StateService } from "@uirouter/angularjs";
import { GtmhubController } from "@gtmhub/core";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";
import { HomeService } from "@gtmhub/home/services/home";
import { HomeScreenView } from "@gtmhub/home/utils";
import { CurrentUserService } from "@gtmhub/users";

export class HomeScreenCtrl extends GtmhubController {
  active: HomeScreenView;
  static $inject = ["$scope", "$rootScope", "CurrentUserService", "HomeService", "$state"];

  constructor(
    private $scope: IScope,
    private $rootScope: ITraceRootScopeService,
    private currentUserService: CurrentUserService,
    private homeService: HomeService,
    private $state: StateService
  ) {
    super();
  }

  $onInit(): void {
    this.active = this.currentUserService.getUserSetting("homeScreen") || HomeScreenView.dashboard;

    this.$scope.$on("toggleChangeTab", (e, tab): void => {
      this.changeTab(tab);
    });
  }

  changeTab = (tab: HomeScreenView) => {
    this.active = tab;
    this.homeService.notifyTabChanged(this.$rootScope, tab);

    if (tab === HomeScreenView.feed) {
      this.$state.go("gtmhub.home.feed");
    } else {
      this.$state.go("gtmhub.home.dashboard");
    }
  };
}

export const HomeScreenComponent: IComponentOptions = {
  controller: HomeScreenCtrl,
  template: require("./home-screen.html"),
};
